/* LabCharge – Build Your Own Set offer page
 * 1) computeOffer()  – pure pricing/unlock maths
 * 2) builder UI      – steppers, rewards card, summary, sticky bar, confetti
 * 3) checkout        – clear cart -> add lines (+plug-in tier variant, +free plug-ins) -> discount URL -> /checkout
 * 4) timer + {tokens}
 *
 * PRICING MODEL
 *  purifiers (colors):  retail each; if units >= discountQty -> discountPct% off (Shopify discount code does the same at checkout)
 *  plug-ins:            variant 1 = Regular price; variant 2 = VIP price once units >= addonDropQty; variant 3 = $0 FREE ×giftQty once units >= giftUnlockQty
 */
(function () {
  'use strict';
  var D = document;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }

  /* ------------------------------------------------------------------ */
  /* 1. PURE MATHS – lines: [{kind:'unit'|'addon', price:<cents>, qty}]  */
  /* (addon price is ignored; it comes from the tier)                    */
  /* ------------------------------------------------------------------ */
  function dropActive(units, cfg) { return !!cfg.addonEnabled && cfg.addonDropQty > 0 && cfg.addonVip < cfg.addonRegular && units >= cfg.addonDropQty; }
  function addonPrice(units, cfg) { return dropActive(units, cfg) ? cfg.addonVip : cfg.addonRegular; }

  function computeOffer(lines, cfg) {
    var units = 0, retail = 0, discount = 0, addonSave = 0, i, l;
    for (i = 0; i < lines.length; i++) if (lines[i].kind === 'unit') units += lines[i].qty;
    var discountOn = cfg.discountPct > 0 && units >= cfg.discountQty;
    var giftOn = !!cfg.giftEnabled && cfg.giftQty > 0 && units >= cfg.giftUnlockQty;
    var dropOn = dropActive(units, cfg);
    for (i = 0; i < lines.length; i++) {
      l = lines[i];
      if (l.kind === 'unit') {
        retail += l.price * l.qty;
        if (discountOn) discount += Math.round(l.price * l.qty * cfg.discountPct / 100);
      } else {
        retail += cfg.addonRegular * l.qty;
        if (dropOn) addonSave += (cfg.addonRegular - cfg.addonVip) * l.qty;
      }
    }
    return {
      units: units, retail: retail, discount: discount, addonSave: addonSave,
      total: retail - discount - addonSave,
      discountOn: discountOn, giftOn: giftOn, dropOn: dropOn,
      addonUnit: addonPrice(units, cfg), giftValue: giftOn ? cfg.giftQty * cfg.giftValue : 0
    };
  }
  function unitAfterDiscount(price, pct) { return Math.round(price * (100 - pct) / 100); }
  function milestones(cfg) {
    var m = [];
    if (cfg.addonEnabled && cfg.addonDropQty > 0 && cfg.addonVip < cfg.addonRegular) m.push({ qty: cfg.addonDropQty, key: 'plug' });
    if (cfg.discountPct > 0) m.push({ qty: cfg.discountQty, key: 'discount' });
    if (cfg.giftEnabled && cfg.giftQty > 0) m.push({ qty: cfg.giftUnlockQty, key: 'gift' });
    m.sort(function (a, b) { return a.qty - b.qty; });
    return m;
  }
  /* cost if the customer added `extra` more purifiers at their average unit price */
  function projectedTotal(lines, cfg, extra) {
    var units = 0, unitRetail = 0, i, copy = lines.slice();
    for (i = 0; i < lines.length; i++) if (lines[i].kind === 'unit') { units += lines[i].qty; unitRetail += lines[i].price * lines[i].qty; }
    if (!units) return null;
    copy.push({ kind: 'unit', price: Math.round(unitRetail / units), qty: extra });
    return computeOffer(copy, cfg).total;
  }
  window.LCBYO = { computeOffer: computeOffer, milestones: milestones, projectedTotal: projectedTotal, unitAfterDiscount: unitAfterDiscount };

  var cfgEl = $('[data-byo-config]');
  var cfg = null;
  if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = null; } }
  if (cfg) cfg.addonDropPct = (cfg.addonRegular > 0 && cfg.addonVip < cfg.addonRegular) ? Math.round((cfg.addonRegular - cfg.addonVip) * 100 / cfg.addonRegular) : 0;
  var fmtr = null;
  function money(c) {
    if (!fmtr) {
      try { fmtr = new Intl.NumberFormat((cfg && cfg.locale) || undefined, { style: 'currency', currency: (cfg && cfg.currency) || 'USD' }); }
      catch (e) { fmtr = { format: function (n) { return '$' + n.toFixed(2); } }; }
    }
    return fmtr.format(c / 100);
  }
  function reducedMotion() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ------------------------------------------------------------------ */
  /* 4a. {token} replacement                                             */
  /* ------------------------------------------------------------------ */
  function replaceTokens() {
    if (!cfg) return;
    var map = {
      '{pct}': String(cfg.discountPct), '{qty}': String(cfg.discountQty),
      '{giftqty}': String(cfg.giftQty), '{giftunlock}': String(cfg.giftUnlockQty),
      '{giftvalue}': money(cfg.giftValue * cfg.giftQty), '{max}': String(cfg.maxPerColor),
      '{dropqty}': String(cfg.addonDropQty), '{droppct}': String(cfg.addonDropPct), '{dropprice}': money(cfg.addonVip), '{baseprice}': money(cfg.addonRegular)
    };
    var w = D.createTreeWalker(D.body, NodeFilter.SHOW_TEXT, null), n, nodes = [];
    while ((n = w.nextNode())) {
      if (n.nodeValue.indexOf('{') > -1 && n.parentNode && !/^(SCRIPT|STYLE)$/.test(n.parentNode.nodeName)) nodes.push(n);
    }
    nodes.forEach(function (t) {
      var v = t.nodeValue;
      for (var k in map) if (map.hasOwnProperty(k)) v = v.split(k).join(map[k]);
      t.nodeValue = v;
    });
    $$('[aria-label*="{"],[placeholder*="{"]').forEach(function (el) {
      ['aria-label', 'placeholder'].forEach(function (a) {
        var v = el.getAttribute(a); if (!v) return;
        for (var k in map) if (map.hasOwnProperty(k)) v = v.split(k).join(map[k]);
        el.setAttribute(a, v);
      });
    });
  }
  replaceTokens();

  /* ------------------------------------------------------------------ */
  /* 4b. Limited-time bar                                                */
  /* ------------------------------------------------------------------ */
  var expired = false;
  function initTimer() {
    var el = $('[data-byo-timer]'); if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 0;
    var fixed = Date.parse(el.getAttribute('data-end') || ''), end;
    if (!isNaN(fixed)) end = fixed;
    else {
      if (hours <= 0) { el.hidden = true; return; }
      var key = 'lc_byo_start', start = null, q = /[?&]t=(\d{9,13})/.exec(location.search);
      if (q) { start = parseInt(q[1], 10); if (start < 1e11) start *= 1000; }
      else { try { start = parseInt(localStorage.getItem(key), 10) || null; } catch (e) { } }
      if (!start) { start = Date.now(); try { localStorage.setItem(key, String(start)); } catch (e) { } }
      end = start + hours * 3600 * 1000;
    }
    var txt = $('[data-byo-timer-text]'), label = $('[data-byo-timer-label]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        expired = true; D.body.classList.add('byo-expired');
        if (txt) txt.textContent = '00:00:00';
        if (label) label.textContent = el.getAttribute('data-expired') || 'Offer ended';
        el.hidden = false; D.dispatchEvent(new Event('byo:expired')); return;
      }
      var s = Math.floor(left / 1000);
      if (txt) txt.textContent = (s >= 86400 ? Math.floor(s / 86400) + 'd ' : '') + pad(Math.floor(s % 86400 / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      setTimeout(tick, 500);
    }
    tick();
  }
  initTimer();

  /* ------------------------------------------------------------------ */
  /* confetti                                                            */
  /* ------------------------------------------------------------------ */
  function confetti() {
    if (reducedMotion()) return;
    var c = D.createElement('canvas'); c.className = 'byo-confetti'; c.setAttribute('aria-hidden', 'true');
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = window.innerWidth, H = window.innerHeight;
    c.width = W * dpr; c.height = H * dpr; D.body.appendChild(c);
    var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    var colors = ['#F94144', '#F8961E', '#F9C74F', '#43AA8B', '#4D96FF', '#B565D9', '#FF6FB5', '#FFFFFF'];
    var P = [], i, N = W < 600 ? 110 : 190;
    for (i = 0; i < N; i++) P.push({
      x: Math.random() * W, y: -20 - Math.random() * H * 0.55,
      vx: (Math.random() - .5) * 2.2, vy: 2 + Math.random() * 3.4,
      w: 6 + Math.random() * 6, h: 9 + Math.random() * 8, r: Math.random() * 6.28, vr: (Math.random() - .5) * .35,
      c: colors[(Math.random() * colors.length) | 0], round: Math.random() < .25
    });
    var t0 = Date.now();
    (function frame() {
      ctx.clearRect(0, 0, W, H); var alive = 0;
      for (var j = 0; j < P.length; j++) {
        var p = P[j]; p.x += p.vx + Math.sin((p.y + j) / 38) * .6; p.y += p.vy; p.vy += .028; p.r += p.vr;
        if (p.y < H + 30) alive++;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c;
        if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.28); ctx.fill(); } else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (alive && Date.now() - t0 < 5200) requestAnimationFrame(frame); else c.parentNode && c.parentNode.removeChild(c);
    })();
  }
  window.LCBYO.confetti = confetti;

  /* ------------------------------------------------------------------ */
  /* 2. BUILDER UI                                                       */
  /* ------------------------------------------------------------------ */
  var root = $('[data-byo-builder]');
  if (!root || !cfg) return;

  var rows = $$('[data-byo-row]', root).map(function (el) {
    return {
      el: el, kind: el.hasAttribute('data-addon') ? 'addon' : 'unit',
      id: parseInt(el.getAttribute('data-variant-id'), 10), name: el.getAttribute('data-name'),
      price: parseInt(el.getAttribute('data-price'), 10) || 0, max: parseInt(el.getAttribute('data-max'), 10) || cfg.maxPerColor,
      sold: el.classList.contains('is-soldout'), popular: parseInt(el.getAttribute('data-popular'), 10) || 0, qty: 0,
      imgSrc: (function () { var im = $('.byo-row__img img', el); return im ? (im.getAttribute('src') || '') : ''; })(),
      minus: $('[data-byo-minus]', el), plus: $('[data-byo-plus]', el), count: $('[data-byo-count]', el), priceEl: $('[data-byo-price]', el)
    };
  });
  var $rw = $('[data-byo-rw]', root), $fill = $('[data-byo-fill]', root), $headline = $('[data-byo-headline]', root),
    $units = $('[data-byo-units]', root), $need = $('[data-byo-need]', root), $subtext = $('[data-byo-subtext]', root),
    $pill = $('[data-byo-pill]', root), $marks = $('[data-byo-marks]', root), $lines = $('[data-byo-lines]', root),
    $sumDl = $('[data-byo-sum]', root), $subtotal = $('[data-byo-subtotal]', root), $subsave = $('[data-byo-subsave]', root),
    $cta = $('[data-byo-cta]', root), $ctaLabel = $('[data-byo-cta-label]', root), $err = $('[data-byo-error]', root),
    $sticky = $('[data-byo-sticky]'), $stickyBtn = $('[data-byo-sticky-btn]'), $stickyTotal = $('[data-byo-sticky-total]'),
    $stickySub = $('[data-byo-sticky-sub]'), $quick = $('[data-byo-popular]', root),
    rPlug = $('[data-byo-reward="plug"]', root), rDiscount = $('[data-byo-reward="discount"]', root), rGift = $('[data-byo-reward="gift"]', root);

  var ms = milestones(cfg), maxM = ms.length ? ms[ms.length - 1].qty : 1;
  var prevDiscount = false, prevGift = false, prevDrop = false, first = true;

  function rewardText(keys) {
    var parts = [];
    keys.forEach(function (k) {
      if (k === 'plug') parts.push('plug-ins ' + cfg.addonDropPct + '% OFF');
      if (k === 'discount') parts.push(cfg.discountPct + '% OFF');
      if (k === 'gift') parts.push(cfg.giftQty + ' FREE plug-in' + (cfg.giftQty > 1 ? 's' : ''));
    });
    return parts.join(' + ');
  }
  var $chip = $('[data-byo-freechip]', root), $chipTxt = $chip && $('span', $chip);
  function allLines() { return rows.map(function (r) { return { kind: r.kind, price: r.price, qty: r.qty }; }); }

  function render() {
    var L = allLines(), o = computeOffer(L, cfg), i;

    /* rows */
    rows.forEach(function (r) {
      r.count.textContent = r.qty; r.el.classList.toggle('has-qty', r.qty > 0);
      r.minus.disabled = r.qty <= 0 || r.sold; r.plus.disabled = r.sold || r.qty >= r.max;
      if (!r.priceEl || r.sold) return;
      if (r.kind === 'unit') {
        if (o.discountOn) r.priceEl.innerHTML = '<s>' + money(r.price) + '</s><span>' + money(unitAfterDiscount(r.price, cfg.discountPct)) + '</span><small>each</small>';
        else if (cfg.discountPct > 0) r.priceEl.innerHTML = '<span>' + money(r.price) + '</span><small>each</small><span class="hint">' + money(unitAfterDiscount(r.price, cfg.discountPct)) + ' at ' + cfg.discountQty + '+</span>';
        else r.priceEl.innerHTML = '<span>' + money(r.price) + '</span><small>each</small>';
      } else {
        var h = '';
        if (o.dropOn) h = '<s>' + money(cfg.addonRegular) + '</s><span>' + money(cfg.addonVip) + '</span><small>each</small><b class="byo-off">' + cfg.addonDropPct + '% OFF</b>';
        else {
          h = '<span>' + money(cfg.addonRegular) + '</span><small>each</small>';
          if (cfg.addonDropQty > 0 && cfg.addonVip < cfg.addonRegular) h += '<span class="hint">' + cfg.addonDropPct + '% OFF (' + money(cfg.addonVip) + ') at ' + cfg.addonDropQty + '+ purifiers</span>';
        }
        r.priceEl.innerHTML = h;
      }
    });

    if ($quick) {
      var isPop = rows.some(function (r) { return r.kind === 'unit' && r.popular > 0 && !r.sold; }) && rows.every(function (r) { return r.kind !== 'unit' || r.sold || r.qty === Math.min(r.popular, r.max); });
      if (!$quick._b) { $quick._b = $('b', $quick); $quick._s = $('small', $quick); $quick._b0 = $quick._b.textContent; $quick._s0 = $quick._s.textContent; }
      $quick.classList.toggle('is-on', isPop);
      $quick._b.textContent = isPop ? '\u2713 ' + $quick._b0.replace(/^Not sure\? Use/, 'Using') + ' \u2013 tap to clear' : $quick._b0;
      $quick._s.textContent = $quick._s0;
    }
    if ($chip) {
      $chip.classList.toggle('is-on', o.giftOn);
      $chipTxt.textContent = o.giftOn ? '\u2713 ' + cfg.giftQty + ' FREE plug-in' + (cfg.giftQty > 1 ? 's' : '') + ' already included in your order' : cfg.giftQty + ' FREE plug-in' + (cfg.giftQty > 1 ? 's' : '') + ' when you pick ' + cfg.giftUnlockQty + ' purifiers';
    }

    /* progress */
    var pct = Math.min(100, o.units / maxM * 100), next = null;
    for (i = 0; i < ms.length; i++) if (ms[i].qty > o.units) { next = ms[i]; break; }
    $fill.style.width = (o.units > 0 ? Math.max(pct, 6) : 0) + '%';
    var all = !next;
    $rw.classList.toggle('is-unlocked', all && ms.length > 0);
    $units.textContent = o.units; $need.textContent = maxM;
    if (all) {
      $headline.textContent = rewardText(ms.map(function (m) { return m.key; }).filter(function (k) { return k !== 'plug' || ms.length === 1; })) + ' unlocked!';
      var sv = o.discount + o.addonSave;
      $subtext.textContent = (sv || o.giftValue) ? 'You are saving ' + money(sv) + (o.giftValue ? ' + ' + cfg.giftQty + ' FREE plug-in' + (cfg.giftQty > 1 ? 's' : '') + ' (' + money(o.giftValue) + ' value)' : '') : 'Reward unlocked';
    } else {
      var k = next.qty - o.units, keysAtNext = ms.filter(function (m) { return m.qty === next.qty; }).map(function (m) { return m.key; });
      $headline.textContent = (o.units === 0 ? 'Pick ' + next.qty + ' purifiers to unlock ' : 'Add ' + k + ' more to unlock ') + rewardText(keysAtNext);
      var proj = o.units > 0 ? projectedTotal(L, cfg, k) : null;
      $subtext.textContent = (proj !== null && proj < o.total)
        ? 'Add ' + k + ' more and your total drops from ' + money(o.total) + ' to ' + money(proj)
        : 'Your savings climb with every purifier you add';
    }
    $pill.classList.toggle('is-on', o.discountOn);
    $pill.textContent = o.discountOn ? cfg.discountPct + '% OFF APPLIED' : 'Pick ' + cfg.discountQty + '+ → ' + cfg.discountPct + '% OFF' + (cfg.giftEnabled ? ' + FREE gift' : '');
    if (rPlug) rPlug.classList.toggle('is-unlocked', o.dropOn);
    if (rDiscount) rDiscount.classList.toggle('is-unlocked', o.discountOn);
    if (rGift) rGift.classList.toggle('is-unlocked', o.giftOn);

    /* celebrate newly unlocked rewards (confetti only for the big ones) */
    if (!first) {
      var big = (o.discountOn && !prevDiscount) || (o.giftOn && !prevGift), small = o.dropOn && !prevDrop;
      if (big || small) { $rw.classList.remove('pop'); void $rw.offsetWidth; $rw.classList.add('pop'); }
      if (big) confetti();
    }
    prevDiscount = o.discountOn; prevGift = o.giftOn; prevDrop = o.dropOn; first = false;

    /* summary */
    var picked = rows.filter(function (r) { return r.qty > 0; }), html = '';
    function thumb(src, qty) { return '<span class="byo-sum__img">' + (src ? '<img src="' + esc(src) + '" alt="" width="52" height="52">' : '') + '<em>' + qty + '</em></span>'; }
    function was(a, b) { return a > b ? '<s class="byo-was">' + money(a) + '</s>' : ''; }
    var addonImg = ''; rows.forEach(function (r) { if (r.kind === 'addon') addonImg = r.imgSrc; });
    picked.forEach(function (r) {
      var lineRetail, lineNow, each;
      if (r.kind === 'unit') { lineRetail = r.price * r.qty; lineNow = lineRetail - (o.discountOn ? Math.round(lineRetail * cfg.discountPct / 100) : 0); each = lineNow / r.qty; }
      else { lineRetail = cfg.addonRegular * r.qty; lineNow = o.addonUnit * r.qty; each = o.addonUnit; }
      html += '<li>' + thumb(r.imgSrc, r.qty) + '<span class="byo-sum__tx"><b>' + esc(r.name) + (r.kind === 'unit' ? ' Air Purifier' : '') + '</b><small>' + money(each) + ' each' + (r.kind === 'addon' && o.dropOn ? ' \u00b7 ' + cfg.addonDropPct + '% OFF' : '') + '</small></span><span class="byo-sum__pr">' + was(lineRetail, lineNow) + '<b>' + money(lineNow) + '</b></span></li>';
    });
    if (o.giftOn) html += '<li class="gift">' + thumb(addonImg, cfg.giftQty) + '<span class="byo-sum__tx"><b>' + esc(cfg.giftName) + '</b><small>FREE gift</small></span><span class="byo-sum__pr"><s class="byo-was">' + money(o.giftValue) + '</s><b>FREE</b></span></li>';
    $lines.innerHTML = html || '<li class="empty">Nothing selected yet – tap + on a color above.</li>';
    $sumDl.innerHTML = picked.length
      ? '<div><dt>Retail value</dt><dd>' + money(o.retail) + '</dd></div>' +
      (o.discount ? '<div class="disc"><dt>Set discount (' + cfg.discountPct + '% OFF)</dt><dd>−' + money(o.discount) + '</dd></div>' : '') +
      (o.addonSave ? '<div class="disc"><dt>Plug-in price drop</dt><dd>−' + money(o.addonSave) + '</dd></div>' : '') +
      '<div class="ship"><dt>Shipping</dt><dd>' + esc(cfg.shippingText) + '</dd></div>' +
      '<div class="grand"><dt>Total</dt><dd>' + was(o.retail, o.total) + money(o.total) + '</dd></div>'
      : '';
    $subtotal.innerHTML = was(o.retail, o.total) + '<span>' + money(o.total) + '</span>';
    var saved = o.discount + o.addonSave;
    $subsave.textContent = (saved || o.giftOn) ? 'You save ' + money(saved) + (o.giftOn ? ' + ' + cfg.giftQty + ' FREE plug-in' + (cfg.giftQty > 1 ? 's' : '') : '') : 'Pick your colors';
    saved = saved || (o.giftOn ? 1 : 0);
    $subsave.classList.toggle('save', !!saved);

    /* CTA */
    var hasUnits = o.units > 0, dead = expired;
    $cta.disabled = !hasUnits || dead; if ($stickyBtn) $stickyBtn.disabled = $cta.disabled;
    $ctaLabel.textContent = dead ? 'This offer has ended' : (hasUnits ? cfg.ctaLabel.replace('{total}', money(o.total)) : cfg.ctaEmptyLabel);
    if ($stickyBtn) $stickyBtn.firstElementChild.textContent = dead ? 'Offer ended' : (hasUnits ? 'Checkout' : 'Pick colors');
    if ($stickyTotal) $stickyTotal.innerHTML = was(o.retail, o.total) + '<span>' + money(o.total) + '</span>';
    if ($stickySub) $stickySub.textContent = o.units + ' purifier' + (o.units === 1 ? '' : 's') + (o.discountOn ? ' · ' + cfg.discountPct + '% OFF' : '') + (o.giftOn ? ' + ' + cfg.giftQty + ' free' : '') + ((o.discount + o.addonSave) ? ' \u00b7 save ' + money(o.discount + o.addonSave) : '');
    updateSticky();
  }

  if ($marks) {
    ms.forEach(function (m) {
      if (m.qty >= maxM) return; var s = D.createElement('span'); s.className = 'byo-rw__mark'; s.style.left = (m.qty / maxM * 100) + '%'; $marks.appendChild(s);
    });
  }

  rows.forEach(function (r) {
    r.plus.addEventListener('click', function () { if (r.qty < r.max && !r.sold) { r.qty++; hideErr(); render(); } });
    r.minus.addEventListener('click', function () { if (r.qty > 0) { r.qty--; hideErr(); render(); } });
  });
  if ($quick) {
    var anyPop = rows.some(function (r) { return r.popular > 0 && r.kind === 'unit' && !r.sold; });
    $quick.hidden = !anyPop;
    $quick.addEventListener('click', function () {
      var on = $quick.classList.contains('is-on');
      rows.forEach(function (r) { if (r.kind === 'unit') r.qty = (on || r.sold) ? 0 : Math.min(r.popular, r.max); });
      hideErr(); render();
    });
  }
  function hideErr() { if ($err) { $err.hidden = true; $err.textContent = ''; } }
  function showErr(m) { if ($err) { $err.textContent = m; $err.hidden = false; $err.scrollIntoView({ block: 'center', behavior: 'smooth' }); } }

  /* sticky checkout bar: visible on desktop + mobile whenever something is selected */
  function updateSticky() {
    if (!$sticky) return;
    $sticky.classList.toggle('is-show', rows.some(function (r) { return r.qty > 0; }));
  }

  /* ------------------------------------------------------------------ */
  /* 3. CHECKOUT                                                         */
  /* ------------------------------------------------------------------ */
  var busy = false;
  function post(url, body) {
    return fetch(cfg.root + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : '{}' });
  }
  function checkout() {
    if (busy || expired) return;
    var o = computeOffer(allLines(), cfg), items = [], picked = rows.filter(function (r) { return r.qty > 0; });
    if (!o.units) return;
    picked.forEach(function (r) {
      var id = r.id;
      if (r.kind === 'addon') id = (o.dropOn && cfg.addonVipId) ? cfg.addonVipId : cfg.addonRegularId;
      items.push({ id: id, quantity: r.qty, properties: { '_offer': 'byo', '_offer_role': r.kind === 'addon' ? 'addon' : 'unit' } });
    });
    if (o.giftOn && cfg.giftVariantId) items.push({ id: cfg.giftVariantId, quantity: cfg.giftQty, properties: { '_offer': 'byo', '_offer_role': 'gift' } });
    else if (o.giftOn) console.warn('[byo] gift unlocked but no FREE (3rd) variant found');
    busy = true; $cta.classList.add('is-busy'); hideErr();
    var prev = $ctaLabel.textContent; $ctaLabel.textContent = 'Preparing your checkout…';
    post('cart/clear.js').then(function () { return post('cart/add.js', { items: items }); })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () { return post('cart/update.js', { attributes: { 'offer_page': 'byo', 'offer_units': String(o.units), 'offer_discount_pct': o.discountOn ? String(cfg.discountPct) : '0', 'offer_gift': o.giftOn ? 'yes' : 'no' } }); })
      .then(function () {
        var dest = cfg.root + 'checkout';
        if (o.discountOn && cfg.discountCode) dest = cfg.root + 'discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=' + encodeURIComponent(cfg.root + 'checkout');
        window.location.href = dest;
      })
      .catch(function (e) {
        busy = false; $ctaLabel.textContent = prev; render();
        showErr('Sorry – ' + (e && e.message ? e.message : 'something went wrong') + '. Please adjust your set and try again.');
      });
  }
  $cta.addEventListener('click', checkout);
  if ($stickyBtn) $stickyBtn.addEventListener('click', checkout);
  D.addEventListener('byo:expired', render);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; render(); } });

  render();
  window.LCBYO._rows = rows; window.LCBYO._render = render;
})();
